import "./src/styles/global.css";
import { checkHash, isBrowser, scroller } from './src/utils/scroll'

export const onClientEntry = () => {
  // IntersectionObserver (ex.: Safari 12/13, WebViews and lazy-loading / on-scroll)
  if (!('IntersectionObserver' in window)) {
    require('intersection-observer');
  }

  // Confirm if relevant need (really old Safari/Android or WebViews)
  // if (!('fetch' in window)) require('whatwg-fetch');
  // if (!('URL' in window) || !('URLSearchParams' in window)) require('url-polyfill');

  
}

export { wrapPageElement } from './gatsby-ssr'

export const onRouteUpdate = ({ location }) => {
  let windowHash

  if (isBrowser) {
    windowHash = window.gatsby_scroll_hash
  }

  if (windowHash) {
    scroller(windowHash)
  } else {
    checkHash(location)
  }

  if (isBrowser && windowHash) {
    window.gatsby_scroll_hash = undefined
  }
}
